import { Capacitor } from "@capacitor/core";
import { Browser } from "@capacitor/browser";

/**
 * Opens a web page outside the app. In the iOS/Android apps a plain
 * target="_blank" link loads the page inside the app's own web view instead
 * (allowNavigation is "*"), replacing the app with no way back.
 */
export async function openExternal(url: string): Promise<void> {
  if (Capacitor.isNativePlatform()) {
    await Browser.open({ url });
  } else {
    window.open(url, "_blank", "noopener,noreferrer");
  }
}

/** onClick for an <a href target="_blank">: opens its href with openExternal. */
export function openLinkExternally(e: React.MouseEvent<HTMLAnchorElement>) {
  if (!Capacitor.isNativePlatform()) return; // Browsers handle target="_blank" fine.
  e.preventDefault();
  openExternal(e.currentTarget.href).catch(console.error);
}
